export class ToTopTextStyle {
  position = '';
  gap = 'uk-grid-column-small';

  static normalize(styles: Partial<ToTopTextStyle>): ToTopTextStyle {
    const pureStyles = new ToTopTextStyle();

    pureStyles.position = styles.position ?? pureStyles.position;
    pureStyles.gap = styles.gap ?? pureStyles.gap;

    return pureStyles;
  }
}
